(function() {
  
  function loadCorrectImage(imageContainer, variantTitle, productHandle) {
    const normalizedTitle = variantTitle.toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/ä/g, 'a')
      .replace(/ö/g, 'o')
      .replace(/ü/g, 'u')
      .replace(/ß/g, 's')
      .replace(/[()]/g, '')
      .replace(/-\//g, '')
      .replace(/--+/g, '-')
      .replace(/-gold/g, '')
      .replace(/-silber/g, '');
    
    const searchAlt = '#farbe_' + normalizedTitle;
    
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        const productImages = product.media || product.images || [];
        
        const matchingImage = productImages.find(img => {
          if (!img.alt) return false;
          
          const imgAlt = img.alt.toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/ä/g, 'a')
            .replace(/ö/g, 'o')
            .replace(/ü/g, 'u')
            .replace(/ß/g, 's')
            .replace(/[()]/g, '')
            .replace(/-\//g, '')
            .replace(/--+/g, '-')
            .replace(/-gold/g, '')
            .replace(/-silber/g, '');
          
          if (!imgAlt.includes('#farbe_')) {
            return false;
          }
          
          const altColorPart = imgAlt.split('#farbe_')[1];
          if (!altColorPart) return false;
          
          const altColor = altColorPart.split(/[\s_]/)[0];
          const searchColor = searchAlt.replace('#farbe_', '');
          
          return altColor === searchColor;
        });
        
        if (matchingImage) {
          let imageSrc = matchingImage.src || matchingImage;
          
          if (imageSrc && !imageSrc.startsWith('http')) {
            imageSrc = 'https:' + imageSrc;
          }
          
          imageContainer.removeAttribute('srcset');
          imageContainer.removeAttribute('sizes');
          imageContainer.src = imageSrc;
          imageContainer.alt = matchingImage.alt || '';
        } else {
        }
      })
      .catch(err => {
      });
  }
  
  function setupVariantPickers() {
    const allSelects = document.querySelectorAll('.variant-picker-select');
    
    allSelects.forEach(select => {
      if (select.dataset.initialized === 'true') {
        return;
      }
      
      const productId = select.dataset.productId;
      const checkboxId = select.dataset.checkboxId;
      const checkbox = document.getElementById(checkboxId);
      
      if (!checkbox) {
        return;
      }
      
      
      const productCard = select.closest('.horizontal-product');
      const imageContainer = productCard ? productCard.querySelector('.horizontal-product__media img') : null;
      
      const variantOptions = Array.from(select.options).map(option => ({
        id: parseInt(option.value),
        title: option.text.replace(' - Ausverkauft', '').trim()
      }));
      
      
      if (imageContainer) {
        const selectedVariantId = parseInt(select.value);
        const selectedOption = variantOptions.find(v => v.id === selectedVariantId);
        
        if (selectedOption) {
          const productLink = productCard.querySelector('.horizontal-product__title');
          const productHandle = productLink?.getAttribute('href')?.split('/products/')[1]?.split('?')[0];
          
          if (productHandle) {
            loadCorrectImage(imageContainer, selectedOption.title, productHandle);
          }
        }
      }
      
      select.addEventListener('change', function(e) {
        e.stopPropagation();
        const newVariantId = parseInt(this.value);
        const selectedOption = variantOptions.find(v => v.id === newVariantId);
        
        checkbox.setAttribute('data-variant-id', newVariantId);
        
        if (imageContainer && selectedOption) {
          const variantTitle = selectedOption.title.toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/ä/g, 'a')
            .replace(/ö/g, 'o')
            .replace(/ü/g, 'u')
            .replace(/ß/g, 's')
            .replace(/[()]/g, '')
            .replace(/-\//g, '')
            .replace(/--+/g, '-')
            .replace(/-gold/g, '')
            .replace(/-silber/g, '');
          
          const searchAlt = '#farbe_' + variantTitle;
          
          const productLink = productCard.querySelector('.horizontal-product__title');
          const productHandle = productLink?.getAttribute('href')?.split('/products/')[1]?.split('?')[0];
          
          if (productHandle) {
            
            fetch(`/products/${productHandle}.js`)
              .then(response => response.json())
              .then(product => {
                
                const productImages = product.media || product.images || [];
                
                const matchingImage = productImages.find(img => {
                  if (!img.alt) return false;
                  
                  const imgAlt = img.alt.toLowerCase()
                    .replace(/\s+/g, '-')
                    .replace(/ä/g, 'a')
                    .replace(/ö/g, 'o')
                    .replace(/ü/g, 'u')
                    .replace(/ß/g, 's')
                    .replace(/[()]/g, '')
                    .replace(/-\//g, '')
                    .replace(/--+/g, '-')
                    .replace(/-gold/g, '')
                    .replace(/-silber/g, '');
                  
                  if (!imgAlt.includes('#farbe_')) {
                    return false;
                  }
                  
                  const altColorPart = imgAlt.split('#farbe_')[1];
                  if (!altColorPart) return false;
                  
                  const altColor = altColorPart.split(/[\s_]/)[0];
                  const searchColor = searchAlt.replace('#farbe_', '');
                  
                  const matches = altColor === searchColor;
                  
                  return matches;
                });
                
                if (matchingImage) {
                  let imageSrc = matchingImage.src || matchingImage;
                  
                  if (imageSrc && !imageSrc.startsWith('http')) {
                    imageSrc = 'https:' + imageSrc;
                  }
                  
                  const preloadImage = new Image();
                  
                  preloadImage.onload = function() {                    
                    imageContainer.removeAttribute('srcset');
                    imageContainer.removeAttribute('sizes');
                    
                    imageContainer.style.transition = 'opacity 0.15s ease';
                    imageContainer.style.opacity = '0';
                    
                    setTimeout(() => {
                      imageContainer.src = imageSrc;
                      imageContainer.alt = matchingImage.alt || '';
                      imageContainer.style.opacity = '1';
                    }, 150);
                  };
                  
                  preloadImage.onerror = function() {
                  };
                  
                  preloadImage.src = imageSrc;
                  
                } else {
                }
              })
              .catch(err => {
              });
          }
        }
      });
      
      select.dataset.initialized = 'true';
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupVariantPickers);
  } else {
    setupVariantPickers();
  }
  
  const observer = new MutationObserver(function(mutations) {
    let hasNewSelects = false;
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('variant-picker-select') || 
              node.querySelector && node.querySelector('.variant-picker-select')) {
            hasNewSelects = true;
          }
        }
      });
    });
    
    if (hasNewSelects) {
      setTimeout(setupVariantPickers, 100);
    }
  });
  
const container = document.querySelector('.collection, .product-grid, .page-container');
if (container) {
  observer.observe(container, {
    childList: true,
    subtree: true
  });
}
})();